<template>
  <div id="app">
    <img
      class="costin"
      alt="Constantin Lungu — Senior Data Engineer"
      src="./assets/constantin.png"
      width="180"
      height="180"
    >
    <Homepage msg="Constantin Lungu"/>
  </div>
</template>

<script>
import Homepage from './components/Homepage.vue'

export default {
  name: 'App',
  components: {
    Homepage
  }
}
</script>

<style>
*,
*::before,
*::after {
  box-sizing: border-box;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 48px;
  padding: 0 16px;
  max-width: 720px;
  margin-left: auto;
  margin-right: auto;
}

.costin {
  border-radius: 50%;
  width: 180px;
  height: 180px;
  object-fit: cover;
  display: block;
  margin: 0 auto 16px;
}

@media (max-width: 480px) {
  #app {
    margin-top: 28px;
  }

  .costin {
    width: 130px;
    height: 130px;
  }
}
</style>
